import { virtualDir } from "./skyward.base.global";

export function completePerformanceMonitoring(id: number, totalActionTime: number)
{
    $.ajax(
    {
        url: `${virtualDir}SkySys/UsageHistory/CompletePerformanceMonitoring`,
        type: "POST",
        dataType: "JSON",
        data:
        {
            id: id,
            totalActionTimeMilliseconds: totalActionTime
        }
    });
}